var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LabeledText',{ref:"text",attrs:{"text":_vm.box.text,"intervals":_vm.items,"highlight":_vm.hover,"colors":_vm.colors},on:{"clipsChanged":_vm.clipsChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }